import { H3 } from '../../../components/atoms/Heading/Heading';
import { styled } from '../../theme/styled';

// The reason for having the border top is so the last item in the column doesn't have a bottom border.
export const ListItem = styled.li`
  border-top: 1px solid ${(props) => props.theme.configuration.strokeColor};

  &:first-child > button {
    padding-top: ${(props) => props.theme.sizes.xxsmall};
  }
  @media ${({ theme }) => theme.device.mobileL} {
    &:first-child > button {
      padding-top: ${(props) => props.theme.sizes.medium};
    }
  }
`;

export const StyledButton = styled.button`
  background: transparent;
  border: 0;
  font-family: ${(props) => props.theme.font.face};
  text-align: left;
  width: 100%;

  &:hover {
    color: ${(props) => props.theme.configuration.buttonBackgroundColor};
    cursor: pointer;
  }

  padding: ${(props) => props.theme.sizes.medium} 0;
`;

export const LetterGroupContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 1rem;
  border-bottom: 1px solid ${(props) => props.theme.configuration.strokeColor};

  @media ${({ theme }) => theme.device.mobileL} {
    margin-top: ${(props) => props.theme.sizes.xxsmall};
    padding-bottom: ${(props) => props.theme.sizes.xxsmall};
  }
  position: relative;

  /* The GradiantList component renders things before and after these divs */
  &:nth-last-child(3) {
    border-bottom: none;
  }
`;

export const LetterBox = styled.div`
  position: sticky;
  align-self: flex-start;
  top: 1rem;
  margin-right: ${(props) => props.theme.sizes.xsmall};
  margin-bottom: ${(props) => props.theme.sizes.xsmall};

  @media ${({ theme }) => theme.device.mobileL} {
    margin-top: ${(props) => props.theme.sizes.xsmall};
  }

  @media ${({ theme }) => theme.device.mobileL} {
    margin-right: 0;
    min-width: 5rem;
  }
`;

export const LetterCircle = styled(H3)`
  border-radius: 50%;
  width: 2.5rem;
  height: 2.5rem;
  padding: ${(props) => props.theme.sizes.xxsmall};
  margin: 0;
  font-size: ${(props) => props.theme.sizes.normal};
  font-weight: ${(props) => props.theme.font.weights.regular};

  border: 1px solid ${(props) => props.theme.configuration.strokeColor};
  color: ${(props) => props.theme.configuration.secondaryTextColor};
  text-align: center;
  vertical-align: middle;
`;

// The &:before hides the border-top in ListItem from appearing at the top of the list.
// This is a limitation with the css column https://stackoverflow.com/a/23083025. I found no other way of solving this.
export const LetterProviders = styled.ul<{ columnCount: number }>`
  list-style: none;
  display: block;
  padding: 0;
  margin: 0;

  gap: 2.5rem;
  column-count: ${(props) => props.columnCount};
  column-width: 23rem;
  position: relative;

  @media ${({ theme }) => theme.device.tablet} and ${({ theme }) => theme.deviceMaxWidth.laptop} {
    column-width: 17rem;
  }

  &:before {
    content: '';
    width: 100%;
    height: ${(props) => props.theme.sizes.xxsmall};
    position: absolute;
    background-color: ${(props) => props.theme.configuration.backgroundColor};
    bottom: 0px;
    top: 0;
  }
`;
